// Login per mockups/00-login.html. The two-factor field renders only when
// the server says TOTP is enabled (needsTotp) — data-driven, not a design
// deviation from the mockup (which shows the TOTP-enabled state).

import { useState, type FormEvent } from 'react';
import { useIsMobile } from '../lib/useIsMobile';
import { api, ApiError } from '../lib/api';

export default function Login({ needsTotp, onDone }: { needsTotp: boolean; onDone: () => void }) {
  const isMobile = useIsMobile();
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [showTotp, setShowTotp] = useState(needsTotp);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/api/auth/login', {
        method: 'POST',
        json: { password, ...(showTotp && code ? { code } : {}) },
      });
      onDone();
    } catch (err) {
      if (err instanceof ApiError && err.body.needsTotp) {
        setShowTotp(true);
        setError(code ? 'Incorrect code. Try again.' : null);
      } else {
        setError(err instanceof Error ? err.message : 'Login failed.');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-head">
          <div className="logo-mark">S</div>
          <div className="workspace-name">Sheahan OS</div>
          <span className="tag">Operator login</span>
        </div>
        <form onSubmit={submit} className="login-body">
          <div className="login-title">Welcome back.</div>
          <div className="f-field">
            <span className="f-label">Password</span>
            <input
              className="f-input"
              type="password"
              aria-label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
              autoComplete="current-password"
            />
          </div>
          {showTotp && (
            <div className="f-field">
              <span className="f-label">Two-factor code</span>
              <input
                className="f-input mono"
                style={{ letterSpacing: '0.2em' }}
                inputMode="numeric"
                aria-label="Two-factor code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="000 000"
                autoComplete="one-time-code"
              />
            </div>
          )}
          {error && (
            <p className="error-text" style={{ marginBottom: 14 }}>
              {error}
            </p>
          )}
          <button type="submit" className={isMobile ? "cbtn pri wide settings-login-submit" : "btn primary block"} disabled={busy || !password}>
            {busy ? 'Signing in…' : 'Sign in →'}
          </button>
        </form>
        <div className="login-foot">
          <span>os.sheahanstudios.com</span>
          <span>● Systems OK</span>
        </div>
      </div>
    </div>
  );
}
